import { TFunction } from 'i18next'
import React, { FC, PropsWithChildren } from 'react'
import { EventsHook } from '../../hooks/useEvents'

interface NoEventsProps {
	eventsHook: EventsHook
	t: TFunction<'pages_saving'>
}

const NoEvents: FC<PropsWithChildren<NoEventsProps>> = ({ eventsHook, t, children }) => {
	const { isInitialLoading, hasEvents } = eventsHook

	if (isInitialLoading || hasEvents) {
		return null
	}

	return (
		<div className='bg-white dark:bg-[#0d2d30] border border-[#c4c4c4] dark:border-[#144448] rounded-xl p-3 flex flex-col items-center justify-center py-8 px-4 text-center'>
			<div className='mb-4 text-lg font-semibold text-text-dark dark:text-white tracking-wide'>
				{t('noEventsMessage.title')}
			</div>
			<div className='text-sm text-text-grey-200 dark:text-text-grey-100 max-w-sm'>
				{t('noEventsMessage.description')}
			</div>
			{children}
		</div>
	)
}

export default NoEvents
